import { UpgradePage } from '../components/pages/UpgradePage/UpgradePage'
import { getUpgradePageServerSideProps } from '../components/pages/UpgradePage/getUpgradePageServerSideProps'

export const getServerSideProps = getUpgradePageServerSideProps

export default UpgradePage
